import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // DODANO
import Icon from '../../../components/AppIcon';

const SettingsColumnsModal = ({ 
  isOpen, 
  onClose, 
  newColumnName, 
  setNewColumnName, 
  newColumnIsDropdown, 
  setNewColumnIsDropdown, 
  handleAddColumn, // Ovu funkciju pozivamo sa tipom
  isProcessingColumn, 
  columns, 
  columnSettings, 
  toggleColumnDropdown, 
  handleDropColumn 
}) => {
  const { t } = useTranslation(); // HOOK ZA PREVOD
  // DODAJEMO: Lokalni state za tip kolone, default je 'text'
  const [newColumnType, setNewColumnType] = useState('text');

  if (!isOpen) return null;

  // Funkcija koja spaja ime i tip prije slanja u parent
  const onAddClick = () => {
    if (!newColumnName.trim()) return;
    handleAddColumn(newColumnType); // Šaljemo izabrani tip
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-background/90 backdrop-blur-xl animate-in fade-in duration-300">
      <div className="bg-card w-full max-w-2xl rounded-[3rem] border border-border shadow-2xl overflow-hidden animate-in zoom-in-95">
        
        {/* Header */}
        <div className="p-10 border-b border-border/50 flex justify-between items-center bg-muted/20">
          <div>
            <h2 className="text-2xl font-black uppercase tracking-tighter text-foreground">{t('settings_columns.title')}</h2>
            <p className="text-[10px] text-primary font-black uppercase tracking-widest mt-1 italic">{t('settings_columns.subtitle')}</p>
          </div>
          <button onClick={onClose} className="p-4 hover:bg-muted rounded-2xl transition-all">
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-10 space-y-10">
          {/* SEKCIJA: DODAVANJE NOVE KOLONE (IDENTIČNO KAO CREATE MODAL) */}
          <div className="p-6 bg-primary/5 rounded-[2rem] border border-primary/10 space-y-5">
            <label className="text-[10px] font-black uppercase tracking-widest text-primary ml-1">{t('settings_columns.label_new_field')}</label>
            <div className="flex flex-col gap-4">
              
              <div className="flex gap-3">
                <input 
                  type="text" 
                  placeholder={t('settings_columns.placeholder_name')}
                  className="flex-1 bg-background border border-border/60 rounded-2xl px-5 py-4 text-sm font-bold outline-none focus:ring-4 focus:ring-primary/10 transition-all"
                  value={newColumnName}
                  onChange={(e) => setNewColumnName(e.target.value)}
                />
                
                {/* SELECT IDENTIČAN KAO U CREATE TABLE MODAL */}
                <select 
                  value={newColumnType}
                  onChange={(e) => setNewColumnType(e.target.value)}
                  className="bg-background border border-border/60 rounded-2xl px-4 py-4 text-[10px] font-black uppercase tracking-widest outline-none focus:ring-4 focus:ring-primary/10 cursor-pointer"
                >
                  <option value="text">{t('settings_columns.types.text')}</option>
                  <option value="number">{t('settings_columns.types.number')}</option>
                  <option value="date">{t('settings_columns.types.date')}</option>
                  <option value="boolean">{t('settings_columns.types.boolean')}</option>
                </select>
              </div>

              <div className="flex items-center justify-between px-2">
                <div className="flex items-center gap-3">
                  <input 
                    type="checkbox" 
                    id="newDrop" 
                    checked={newColumnIsDropdown} 
                    onChange={(e) => setNewColumnIsDropdown(e.target.checked)} 
                    className="w-5 h-5 rounded-lg border-border text-primary focus:ring-primary/20 cursor-pointer"
                  />
                  <label htmlFor="newDrop" className="text-[10px] font-black uppercase text-muted-foreground cursor-pointer select-none tracking-widest">
                    {t('settings_columns.label_dropdown')}
                  </label>
                </div>
                <button 
                  onClick={onAddClick} 
                  disabled={isProcessingColumn || !newColumnName}
                  className="px-10 py-4 bg-foreground text-background rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-primary hover:text-white transition-all disabled:opacity-30 shadow-xl"
                >
                  {isProcessingColumn ? t('settings_columns.btn_adding') : t('settings_columns.btn_add')}
                </button>
              </div>
            </div>
          </div>

          {/* UPRAVLJANJE POSTOJEĆIM */}
          <div className="space-y-4">
            <label className="text-[10px] font-black uppercase tracking-widest text-muted-foreground ml-1">{t('settings_columns.label_existing_fields')}</label>
            <div className="grid grid-cols-1 gap-3 max-h-60 overflow-y-auto pr-3 custom-scrollbar">
              {columns.map(col => (
                <div key={col} className="flex items-center justify-between p-4 bg-muted/20 rounded-2xl border border-border/40">
                  <div className="flex flex-col">
                    <span className="text-sm font-black uppercase tracking-tight">{col.replace(/_/g, ' ')}</span>
                    <button 
                      onClick={() => toggleColumnDropdown(col)}
                      className={`text-[9px] font-bold uppercase mt-1 transition-colors text-left ${columnSettings[col]?.type === 'dropdown' ? 'text-primary' : 'text-muted-foreground/40'}`}
                    >
                      {columnSettings[col]?.type === 'dropdown' ? t('settings_columns.status_dropdown_on') : t('settings_columns.status_dropdown_off')}
                    </button>
                  </div>
                  <button 
                    onClick={() => handleDropColumn(col)} 
                    className="p-3 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded-xl transition-all"
                  >
                    <Icon name="Trash2" size={18} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="p-10 bg-muted/10 border-t border-border/50 text-center">
          <button onClick={onClose} className="w-full py-5 rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-muted transition-all">
            {t('settings_columns.btn_close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsColumnsModal;